(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cardSelector = '#product-grid > .grid__item, .collection .product-grid > .grid__item, .featured-collection .grid__item';
  const seen = new WeakSet();
  let observer;
  function revealCards(root = document) {
    if (reduce.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.classList.add('sjbjj-reveal-visible');
        window.setTimeout(() => entry.target.classList.remove('sjbjj-reveal-ready','sjbjj-reveal-visible'), 900);
      });
    }, {rootMargin:'0px 0px 55px 0px', threshold:.08});
    const cards = root.querySelectorAll(cardSelector);
    cards.forEach((card,i) => {
      if (seen.has(card)) return;
      seen.add(card);
      // Cards already visible at initial load should not disappear and reappear.
      const rect = card.getBoundingClientRect();
      if (rect.top < window.innerHeight * .85) return;
      card.style.setProperty('--sjbjj-delay', ((i % 4) * 45) + 'ms');
      card.classList.add('sjbjj-reveal-ready');
      observer.observe(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>revealCards()); else revealCards();
  document.addEventListener('shopify:section:load',event=>revealCards(event.target));
  document.addEventListener('shopify:section:reorder',()=>revealCards());
  if ('MutationObserver' in window) {
    let queued=false;
    new MutationObserver(() => {
      if(queued) return;
      queued=true;
      requestAnimationFrame(()=>{queued=false;revealCards();});
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  reduce.addEventListener('change',()=>{if(reduce.matches) document.querySelectorAll('.sjbjj-reveal-ready').forEach(el=>el.classList.remove('sjbjj-reveal-ready'));});
})();